import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class PickupDropService {


  static getpickupdropCharges(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getpickupdropCharges}?id=${item?.id}`
      }
      else
      if(item?.fromPlace){
        api= `${API_BASE_URL}${API_PATHS.getpickupdropCharges}?fromPlace=${item?.fromPlace}`
     }
     else
     if(item?.toPlace){
        api= `${API_BASE_URL}${API_PATHS.getpickupdropCharges}?toPlace=${item?.toPlace}`
     }
       else{
      api = `${API_BASE_URL}${API_PATHS.getpickupdropCharges}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }




  
static addpickupdropCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addpickupdropCharges}`;
    return axiosInstance
        .post(api,item)
        
}

static editpickupdropCharges(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editpickupdropCharges}`;
    return axiosInstance
        .put(api,item)
        
}

static deletepickupdropCharges(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletepickupdropCharges}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default PickupDropService;